import { useStepState } from 'src/app/pages/startAPetition/pageContext';

import { SkipStep } from '../../SkipStep';

import { AskLoader } from './AskLoader';

export function AskWrapper(): React.JSX.Element {
	const { data } = useStepState();
	const isSkipped = data.petition?.aiPromptChoice === 'ai';

	return isSkipped ? <SkipStep /> : <AskLoader />;
}
